<h2 mat-dialog-title>{{ 'AI_ASSISTANT.GOALS.ADD_GOAL.ADD_A_CAPABILITY' | translate }}</h2>
  <mat-dialog-content class="capability-dialog-content">
    <ai-capabilities-table
      [assistantType]="assistantType"
      [excludedGoalIds]="excludedGoalIds"
      (selectedGoals)="setTableSelectedGoals($event)"
      class="capabilities-table"
    >
    </ai-capabilities-table>
  </mat-dialog-content>
  <mat-dialog-actions align="start" class="actions">
    <button mat-button type="button" color="primary" (click)="newGoal()">
      <mat-icon>add</mat-icon>
      {{ 'AI_ASSISTANT.GOALS.ADD_GOAL.NEW_CAPABILITY' | translate }}
    </button>

    <span class="spacer"></span>

    <button mat-stroked-button mat-dialog-close>{{ 'AI_ASSISTANT.SHARED.CANCEL' | translate }}</button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="tableSelectedGoals().length === 0"
      (click)="chooseGoals(tableSelectedGoals())"
    >
      {{ 'AI_ASSISTANT.SHARED.ADD' | translate }}
    </button>
  </mat-dialog-actions>

